import { render, staticRenderFns } from "./PregnancyTreatmentModal.vue?vue&type=template&id=8f9027de"
import script from "./PregnancyTreatmentModal.vue?vue&type=script&lang=js"
export * from "./PregnancyTreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./PregnancyTreatmentModal.vue?vue&type=style&index=0&id=8f9027de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports